import type { FC } from 'react';

import classNames from 'classnames';

import type { AriaProps } from '@iconik-io/shared-lib/src/react/a11y/aria';

import Button from '../../ui/button/button';
import type { TooltipWrappedProps } from '../tooltip_trigger/tooltip_trigger';

import styles from './segment_color_button.module.css';

type Props = {
  className?: string;
  onClick: () => void;
  aria?: AriaProps;
} & TooltipWrappedProps;

const CommentColorButton: FC<Props> = ({
  className,
  onClick,
  onMouseOver,
  onMouseLeave,
  'data-tooltip': dataTooltip,
  aria,
}) => (
  <Button
    onMouseOver={onMouseOver}
    onMouseLeave={onMouseLeave}
    data-tooltip={dataTooltip}
    className={classNames(styles.button, className)}
    variant="info"
    wideBasis={false}
    noBorder
    onClick={onClick}
    uiKey="comment-highlight-color"
    aria={aria}
  >
    <div className={styles.gradient_circle} />
  </Button>
);

export default CommentColorButton;
